import React from "react";

function FacebookIcon() {
  return (
    <span className="anticon ant-facebook">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 12 24"
      >
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M9.462 3.826h2.103V.162C11.203.112 9.955 0 8.501 0c-3.032 0-5.11 1.908-5.11 5.413V8.64H.045v4.095H3.39V23.04h4.103V12.736h3.211l.51-4.095H7.493V5.82c.001-1.184.32-1.994 1.97-1.994z"
        ></path>
      </svg>
    </span>
  );
}

export default FacebookIcon;
